import { useCallback, useEffect, useState } from 'react';

const useMediaQuery = (mediaQuery: string): boolean => {
  const [matches, setMatches] = useState<boolean>(false);

  const updateTarget = useCallback((event: MediaQueryListEvent): void => {
    if (event.matches) {
      setMatches(true);
    } else {
      setMatches(false);
    }
  }, []);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      // need to set matches on init of the hook
      setMatches(window.matchMedia(mediaQuery).matches);
      const media: MediaQueryList = window.matchMedia(mediaQuery);
      // for better browser compatibility we should use addListener (safari < 14)
      media.addListener(updateTarget);

      return () => media.removeListener(updateTarget);
    }
  }, []);

  return matches;
};

export default useMediaQuery;
